import { useState } from "react";
import { Outlet } from "react-router-dom"; 
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";

const Layout = () => { 
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  return (
    <div className="layout-wrapper">
      <Sidebar
        customClass={sidebarOpen ? "open" : ""}
        handleSidebarClose={() => setSidebarOpen(false)}
      />
      <div className="content-wrapper">
        <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
        <main className="main-content">
          <Outlet /> 
        </main>
      </div>
    </div>
  );
};

export default Layout;